import { Component } from '@angular/core';

@Component({
  selector: 'app-grievance-user1',
  templateUrl: './grievance-user1.component.html',
  styleUrls: ['./grievance-user1.component.scss']
})
export class GrievanceUser1Component {

}
